export default __webpack_public_path__ + "static/media/loading.07ef6632.png";